import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Route, withRouter } from 'react-router-dom';
import { Avatar, Icon, Tooltip, Menu, MenuItem } from '@material-ui/core';
import './Profile.scss';
import { PrismButton } from '../../components';
import { getUserAchievements } from '../../actions/AchievementActions';
import { openProfile, getShoutoutsForUser } from '../../actions/ProfileActions';
import { setSendShoutoutModalProfileUser, setShowSendShoutoutModal, setShowSendShoutoutModalWithUser } from '../../actions/HotkeyActions';
import { markAsRead, updateUser } from '../../actions/UsersActions';
import { showToast, hideToast } from '../../actions/ToastActions';
import { updateShoutoutFilter } from '../../actions/ProfileActions';
import ProfileShoutouts from './ProfileShoutouts';
import ProfileAchievements from './ProfileAchievements';
import EditableText from '../../components/EditableText';

class Profile extends Component {
  state = { user: null, firstName: '', isMe: false, editingJob: false, jobTitle: '',
    editingBio: false, bio: '', showUndoChanges: false, menuOpen: false };

  jobTitleInput = null;
  oldTitle = '';
  oldTitle = '';
  users = null;
  achievements = null;

  UNSAFE_componentWillMount() {
    const { users, match } = this.props;
    if (users.length > 0) {
      const id = match.params.id;
      this.initProfile(id, users);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { users, match } = nextProps;
    if (users.length > 0 && (!this.state.user || this.props.match.params.id !== match.params.id)) {
      const id = match.params.id;
      this.initProfile(id, users);
    } else if (this.state.user) {
      let user = users.filter((user) => user._id === this.state.user._id)[0];
      if (user._id === this.state.user._id && (user.bio !== this.state.user.bio || user.title !== this.state.user.title)) {
        this.initProfile(user._id, users);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.closeCommentOnKey);
  }


  initProfile(id, users) {
    const { openProfile, getUserAchievements, currentUser, markAsRead } = this.props;
    const user = users.find(user => user._id === id);
    const firstName = user.displayName.split(' ')[0];
    const isMe = currentUser.uid === user.uid;
    if (!isMe) this.props.setSendShoutoutModalProfileUser(user);
    if (isMe) {
      markAsRead();
      this.props.setSendShoutoutModalProfileUser(null);
    }
    this.setState({ user, firstName, isMe, jobTitle: user.title, bio: user.bio || '' });
    getUserAchievements(id);
    openProfile(id);
  }

  onShoutoutsScrolledToEnd() {
    const { getShoutoutsForUser } = this.props;
    getShoutoutsForUser();
  }

  sendShoutout() {
    // this.props.setShowSendShoutoutModal(true);
    this.props.setShowSendShoutoutModalWithUser(true);
  }

  handleUndo(section) {
    let user = this.state.user;
    if (section === 'Job Title') user.title = this.oldTitle;
    else if (section === 'User Bio') user.bio = this.oldBio;
    this.setState({ user, editingJob: false, jobTitle: user.title, bio: user.bio }, () => {
      this.props.updateUser(user);
      this.props.hideToast();
    });
  }

  handleUpdateUser(e, section) {
    e.preventDefault();
    e.stopPropagation();
    let user = this.state.user;
    if (section === "Job Title") {
      this.oldTitle = user.title;
      user.title = this.state.jobTitle;
    } else if (section === "User Bio") {
      this.oldBio = user.bio;
      user.bio = this.state.bio;
    }
    this.props.updateUser(user);
    this.setState({ user, editingJob: false, editingBio: false });
    const toastContent = this.renderToastContent(section);
    this.props.showToast(toastContent, 5000, true);
  }

  handleEditProfile() {
    const { isMe, editingJob } = this.state;
    if (!isMe) return;
    this.setState({ editingJob: !editingJob }, () => {
      this.jobTitleInput.focus();
    });
  }

  renderUserBio() {
    const { user, isMe, editingBio, bio } = this.state;
    if (isMe) {
      if (editingBio) {
        return (
          <div className="edit-bio-wrapper">
            <div className="show-edit-bio">
              <textarea
                onBlur={() => this.setState({ editingBio: false })}
                maxLength={250}
                placeholder="Add a brief bio to let people know more about you"
                onChange={(e) => this.setState({ bio: e.target.value })}
                onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") this.handleUpdateUser(e, 'User Bio');
                  let el = document.getElementById('bio-title');
                  el.style.height = "1px";
                  el.style.height = (el.scrollHeight) + "px";
                }}
                id="bio-title"
                value={bio}
                className="bio-editor"
              />
            </div>
            <Icon className="check-icon" onMouseDown={(e) => {
              e.stopPropagation();
              this.handleUpdateUser(e, 'User Bio');
            }}
            >check</Icon>
            <span className="remaining">{bio.length}/250</span>
          </div>
        );
      }
      else {
        return (
          <div
            onClick={() => this.setState({ editingBio: true }, () => {
              let el = document.getElementById('bio-title');
              el.style.height = "1px";
              el.style.height = (el.scrollHeight) + "px";
              el.focus();
            })}
            className={user.bio && user.bio.length ? "bio-text self-bio" : "bio-text self-bio empty-bio"}>
            <div className="bio-words">
              <div>{user.bio || 'Add a brief bio to let people know more about you'}</div>
              <Icon className="edit-bio-icon">create</Icon>
            </div>
          </div>
        );

      }
    }
    else if (user && user.bio && user.bio.length){
      return <div className="bio-text"><div className="bio-words">{user.bio}</div></div>;
    }
  }

  renderJobTitle() {
    const { editingJob, jobTitle, isMe } = this.state;
    const { title } = this.state.user;
    return (
      <div className="job-wrapper">
        <EditableText
          handleUpdate={(e) => this.handleUpdateUser(e, 'Job Title')}
          placeholder={title || 'Employee'}
          value={this.state.jobTitle}
          maxWidth={290}
          canEdit={isMe}
          onChange={(value) => this.setState({ jobTitle: value })}
        />
        {editingJob && <span className="remaining">{jobTitle.length}/50</span> }
      </div>
    );
  }

  renderToastContent(sectionUpdated) {
    return (
      <div className="undo-changes-content">
        <div className="undo-changes-text">{sectionUpdated} updated. <span onClick={this.handleUndo.bind(this, sectionUpdated)}>Undo.</span></div>
      </div>
    );
  }

  renderSendShoutoutButton() {
    const { isMe, user } = this.state;

    if (!isMe) {
      const firstName = user.displayName.split(' ')[0];
      return (
        <div className="shoutout-button-container">
          <PrismButton onClick={this.sendShoutout.bind(this)}>
            SEND {firstName} A SHOUTOUT
          </PrismButton>
        </ div>
      );
    }
    return null;
  }

  renderMiniAchievements() {
    const { achievements } = this.props;
    return achievements.map((achievement, i) => (
      <Tooltip key={i} title={achievement.name}>
        <div className="achievement">
          <img alt={achievement.name} key={achievement.name} src={achievement.picture} width="35" />
        </div>
      </Tooltip>
    ));
  }

  renderLink() {
    const { history } = this.props;
    const { user, firstName } = this.state;
    const { pathname } = history.location;

    return (
      <div>

        <Route exact path="/profile/:id/shoutouts/:shoutout?" render={() =>
          <Link
            ref={(ref) => this.users = ref}
            style={{ color: 'white' }}
            className={pathname === '/users' ? 'active' : ''}
            to="/users"
          >
            <Icon  style={{ fontSize: 35 }}>keyboard_arrow_left</Icon>
            <span className="underline">Back to All Users</span>
          </Link>}
        />
        <Route exact path="/profile/:id/achievements" render={() =>
          <Link
            ref={(ref) => this.achievements = ref}
            style={{ color: 'white' }}
            className={pathname === '/users' ? 'active' : ''}
            to={`/profile/${user.uid}/shoutouts`}
          >
            <Icon  style={{ fontSize: 35 }}>keyboard_arrow_left</Icon>
            <span className="underline">Back to {firstName}'s Shoutouts</span>
          </Link>}
        />
      </div>
    );
  }

  updateFilter(filter){
    this.setState({ menuOpen: false });
    this.props.updateShoutoutFilter(filter);
  }

  render() {
    const { user, isMe } = this.state;

    if (user) {
      const { shoutouts, achievements, allAchievements } = this.props;
      const { displayName, photoURL, _id } = user;
      const { firstName, editingJob } = this.state;
      const isOnAchievements = this.props.location.pathname.indexOf('achievements') !== -1;

      return (
        <div>
          <div className="back-button-row">
            <div className="back-button-row-content">
              <div className="back-to-users">
                {this.renderLink()}
              </div>
              <div style={{ width: 340, height: 1 }}/>
            </div>
            <div
              className={isOnAchievements ? "hide-filter-menu"  : "filter-menu"}
              ref={(ref) => this.filterOptions = ref}
              style={{ paddingTop: 26, paddingRight: 74 }}
            >
              View Shoutouts:
              <PrismButton className="filter-menu" onClick={() => this.setState({ menuOpen: true })}>
                <span style={{ fontWeight: 200 }}>{this.props.shoutoutFilter}</span>
              </PrismButton>
              <Menu className="profile-menu-element"
                anchorEl={this.filterOptions}
                open={this.state.menuOpen}
                onClose={() => this.setState({ menuOpen: false })}>
                <MenuItem onClick={() => this.updateFilter('Received')}>
                  Received
                </MenuItem>
                <MenuItem onClick={() => this.updateFilter('Sent')}>
                  Sent
                </MenuItem>
                <MenuItem onClick={() => this.updateFilter('Sent & Received')}>
                  Sent & Received
                </MenuItem>
              </Menu>
            </div>
          </div>

          <div className="profile-row">
            <div className="user-info">
              <Avatar style={{ height: 150, width: 150, margin: 'auto', marginBottom: 22 }} alt={displayName} src={photoURL} />
              <div className="user-name">
                <div>
                  {displayName}
                </div>
                {this.renderJobTitle()}
                {this.renderUserBio()}
              </div>
            </div>

            {this.renderSendShoutoutButton()}

            <div className={editingJob ? "shoutout-info edit" : "shoutout-info"}>
              <div>
                Shoutouts Received: <strong>{user.shoutoutsReceived || 0}</strong>
              </div>
              <div style={{ marginTop: 18 }}>
                Shoutouts Given: <strong>{user.shoutoutsSent || 0}</strong>
              </div>
            </div>

            <div className="achievements">
              <div>
                <div style={{ flex: 1 }}>
                  <strong>ACHIEVEMENTS</strong>
                  <div style={{ marginTop: 4 }}>
                    <i className="num-earned">{achievements.length} out of {allAchievements.length}</i>
                  </div>
                </div>
                {achievements.length !== 0 &&
                  <Route exact path="/profile/:id/shoutouts" render={() =>
                    <Link to={`/profile/${_id}/achievements`}>
                      {'SEE ALL >'}
                    </Link>}
                  />
                }
              </div>
              <div>
                {this.renderMiniAchievements()}
              </div>
            </div>
          </div>

          <div className="profile-extras">
            <Route exact path="/profile/:id/shoutouts/:shoutout?" render={() =>
              <ProfileShoutouts
                isMe={isMe}
                onSendClick={this.sendShoutout.bind(this)}
                firstName={firstName}
                onShoutoutsScrolledToEnd={this.onShoutoutsScrolledToEnd.bind(this)}
                shoutouts={shoutouts}
              />}
            />
            <Route exact path="/profile/:id/achievements" render={() =>
              <ProfileAchievements
                achievements={achievements}
              />}
            />
          </div>
        </div>
      );
    } else {
      return '';
    }
  }
}

const mapStateToProps = ({ usersStore, hotkeyStore, authStore, profile, achievementsStore }) => {
  const { headers } = authStore;
  const { users, currentUser } = usersStore;
  const { isFocus, profileUser } = hotkeyStore;
  const { shoutouts, shoutoutFilter } = profile;
  const { earnedAchievements, achievements } = achievementsStore;

  const userAchievements = [];
  earnedAchievements.forEach(achievement => {
    if (achievement.earned) {
      let fullAchievement = achievements.find(a => a._id === achievement.achievement);
      if (fullAchievement) {
        fullAchievement.timestamp = achievement.timestamp;
        userAchievements.push(fullAchievement);
      }
    }
  });

  userAchievements.sort((a, b) => {
    let aTime = new Date(a.timestamp).getTime();
    let bTime = new Date(b.timestamp).getTime();
    return bTime - aTime;
  });

  return { users, currentUser, isFocus, profileUser, headers, shoutouts, achievements: userAchievements, allAchievements: achievements, shoutoutFilter };
};

export default withRouter(connect(mapStateToProps, { openProfile, getShoutoutsForUser,
  getUserAchievements, markAsRead, setSendShoutoutModalProfileUser, setShowSendShoutoutModal,
  setShowSendShoutoutModalWithUser, updateUser, showToast, hideToast, updateShoutoutFilter })(Profile));



// WEBPACK FOOTER //
// ./src/screens/profile/Profile.js